function ContextNotes() {
  return <div>Context Notes</div>;
}

export default ContextNotes;
